import React, { Component } from 'react';
import Image from "react-graceful-image";
import './App.css'

import {
	Link
} from 'react-router-dom'

import epiphanies from './images/epiphanies.png'

class HomePage extends Component {
	render() {
		return (
			<div className="App-content">
				<Link to="/epiphanies"><Image src={epiphanies} noLazyLoad="true" placeholderColor="#000" className="App-logo" alt="Epiphanies I & II single art"/></Link>
			</div>
			);
	}
}

export default HomePage;